import { render, staticRenderFns } from "./couponEditTabInformation.vue?vue&type=template&id=4e726e42&scoped=true&"
import script from "./couponEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./couponEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./couponEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e726e42",
  null
  
)

export default component.exports